import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { finalize, take, timeout } from 'rxjs';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { RecallService, SessionService } from '@agenda-customer-ui/data-access';
import { SharedModuleLib } from '../../../../../shared.module';
import { NgIf, NgFor, UpperCasePipe } from '@angular/common';
import { NoContentComponent } from '../no-content/no-content.component';
import { HTTP_CODE, StorageKeys } from '@core/enums';
import { getDayOfWeek, getRecallPrintDate, isSourceFordPass, isSourceMobile, parseDateWithWeek } from '@core/utils';
import { CardHistoryComponent } from '../../../card/card.component';
import { NotificationService } from '../../../../../components/notification/services/notification.service';
import { saveAs } from 'file-saver';
import { RecallHistory } from 'libs/core/src/interfaces/from-history/models';
import { AccordionLibComponent, CardComponent } from '@components/atoms';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'app-recall',
    templateUrl: './recall.component.html',
    styleUrls: ['./recall.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        NgIf,
      SharedModuleLib,
        NoContentComponent,
        CardComponent,
        NgFor,
        AccordionLibComponent,
        CardHistoryComponent,
        UpperCasePipe,
        TranslateModule,
    ],
})
export class RecallComponent implements OnInit {

  @Input() vin!: string;
  @Input() country!: string;
  recallLoaded = true;
  recallHistory!: RecallHistory[];

  lastPrintDate!: string | null;

  isPdfLoading = false;
  lastRecallPrint!: string;
  logoImage!: undefined | string;
  backgroundImage!: undefined | string;

  constructor(
    private historyService: RecallService,
    private translateService: TranslateService,
    private recallService: RecallService,
    private notificationService: NotificationService,
    private translate: TranslateService,
    private sessionService: SessionService
  ) { }

  ngOnInit(): void {
    this.getRecallHistory();
  }

  getRecallHistory() {
    this.recallLoaded = false;
    this.historyService.getRecall(this.vin, 'C', this.country || 'BRA')
    .pipe(
      take(1),
      timeout({each: 8000}),
      finalize(() => {
        this.recallLoaded = true
      }))
        .subscribe(recallHistory => {
          if (recallHistory && recallHistory.httpCode === HTTP_CODE.OK && recallHistory.response.length > 0) {
            this.recallHistory = recallHistory.response;
            this.addDateToList();
            this.lastPrintDate = this.recallHistory[0].launchDate ? getRecallPrintDate(this.recallHistory[0].launchDate) : null;
          }
        });
  }

  parseDate(date: string) {
    const newDate = new Date(date + 'T00:00:00');
    const dayOfWeek = getDayOfWeek(newDate.getDay(), this.country || 'BRA');
    return parseDateWithWeek(newDate, dayOfWeek);
  }

  addDateToList() {
    this.recallHistory?.forEach(history => {
      history.repairDate = history.repairDate ? this.parseDate(history.repairDate) : this.translateService.instant("vehicle-recall.no-date");
    })
  }

  generatePdf() {
    this.isPdfLoading = true;
    this.recallService.getRecallCertificate(this.vin, 'C', this.country).subscribe(
      (response: Blob) => {
        const blob = new Blob([response], { type: 'application/pdf' });
        saveAs(blob, 'CertificadoRecall.pdf');
        this.isPdfLoading = false;
      },
      error => {
        console.error(error.message);
        this.notificationService.add({
          text: this.translate.instant('vehicle_recall.service-error'),
          severity: 'error',
          timeout: 5000,
        });
      },
    );
    this.historyService
      .setNewLastPrintDate(this.vin)
      .pipe(finalize(() => (this.isPdfLoading = false)))
      .subscribe(
        () => {
          const now = new Date();
          this.lastRecallPrint = `${now.getDate().toString().padStart(2, '0')}/${(now.getMonth() + 1).toString().padStart(2, '0')}/${now.getFullYear()}`;
        },
        err => {
         console.error(err);
        },
      );
  }

  wrapLongText(text: string, maxsize: number): string {
    return text.replace(new RegExp(`(?![^\\n]{1,${maxsize}}$)([^\\n]{1,${maxsize}})\\s`, 'g'), '$1\n');
  }

  public getFullDate(date: string): string {
    if (date === null) {
      return '';
    }

    const newDate = new Date(date + 'T00:00:00');

    const month = newDate.getUTCMonth();

    let day = newDate.getUTCDate().toString();
    day = parseInt(day, 10) < 10 ? `0${day}` : day;

    const formatted = ` - ${day} de ${this.translateService.instant('months.'+month)} de ${newDate.getFullYear()}`;
    return formatted;
  }

  public showDownloadButton(): boolean {
    const source = this.sessionService.getItem(StorageKeys.SOURCE);
    return !isSourceFordPass(source) && !isSourceMobile(source);
  }
}

